import type {Schemas} from 'api/dto.generated';
import {sortMarcdata} from '../function/sortMarcdata';

export const mapAuthority = (
  authority: Schemas.Authority,
): Schemas.Authority => {
  return {
    ...authority,
    marcdata: authority?.marcdata
      ? sortMarcdata(authority.marcdata)
      : undefined,
  };
};
